import { useQuery } from "@apollo/client"
import { GET_EXPLORER_TAGS } from "../querys/explorerQuery"
import { TypesGetExplorerTagsResponse } from "../types/TypesExplorer"


export function QueryGetExplorerTags() {
    const { data, loading, error } = useQuery<TypesGetExplorerTagsResponse>(GET_EXPLORER_TAGS)
    return {data, loading, error}
  }
  